import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environments } from 'src/environments/environments';

@Component({
  selector: 'app-credential-footer',
  templateUrl: './credential-footer.component.html',
  styleUrls: ['./credential-footer.component.css'],
  standalone: true,
})
export class CredentialFooterComponent implements OnChanges {

  @Input() logoCampaign : string | null = null;
  @Input() footerBackground = "#000000";
  @Input() footerTextColor = "#ffffff";

  imageError = false;

  public year: number = new Date().getFullYear();
  public email: string = environments.contactMail;
  public landingUrl: string = environments.appUrls.landing;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['logoCampaign']) {
      this.imageError = false;
    }
  }

  onErrorImage() {
    this.imageError = true;
  }
}
